//https://davidwalsh.name/javascript-debounce-function
// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function eldebounce(n, t, u) {
  var e;
  return function () {
    var i = this,
      o = arguments,
      a = function () {
        (e = null), u || n.apply(i, o);
      },
      c = u && !e;
    clearTimeout(e), (e = setTimeout(a, t)), c && n.apply(i, o);
  };
}

jQuery(document).ready(function ($) {
  // ensure  a11y attributes are in place
  // update a117 attributes on events
  // Works with Ajax loaded content
  $(".pagebuilder-list-accordions .heading")
    .attr("role", "button")
    .attr("aria-expanded", "false")
    .attr("tabindex", "0")
    .on("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        $(this).trigger("click");
      }
    });
  $(".pagebuilder-list-accordions .content-block").css({
    display: "none",
  });
  $("body").on("click", ".pagebuilder-list-accordions .heading", function (e) {
    $(e.target).attr("aria-expanded", "false");
    $(".pagebuilder-list-accordions li").removeClass("js-active");
    $(".pagebuilder-list-accordions .content-block").slideUp("fast");
    if ($(this).next().is(":hidden") == true) {
      $(this).parent().addClass("js-active");
      $(this).next().slideDown("fast");
      $(e.target).attr("aria-expanded", "true");
    }
  });

  // Cards slider
  function cardSliderAccordion() {
    $(".pagebuilder-cards-slider .desc-block").css({
      display: "none",
    });
    $("body")
      .off("click", ".pagebuilder-cards-slider .pagebuilder-card")
      .on("click", ".pagebuilder-cards-slider .pagebuilder-card", function (e) {
        $(".pagebuilder-cards-slider .pagebuilder-card").removeClass(
          "js-active"
        );
        $(".pagebuilder-cards-slider .desc-block").slideUp("fast");
        if ($(this).find(".desc-block").is(":hidden") == true) {
          $(this).addClass("js-active");
          $(this).find(".desc-block").slideDown("fast");
        }
      });
  }
  if ($(window).outerWidth() < 992) {
    cardSliderAccordion();
  }

  $(window).on("resize orientationchange", function () {
    if ($(window).outerWidth() < 992) {
      cardSliderAccordion();
    } else {
      $(".pagebuilder-cards-slider .desc-block").css({
        display: "block",
      });
    }
  });

  /*----------  Check if user scrolled  ----------*/
  if ($(".isio .pagebuilder-careers-menu-section").length) {
    var pageScroll = function () {
      var scroll = $(window).scrollTop();
      if (scroll > 20) {
        $("#sticky-wrapper").addClass("is-scrolled");
      } else {
        $("#sticky-wrapper").removeClass("is-scrolled");
      }
    };
    // run on scroll
    window.addEventListener("scroll", pageScroll);

    /* Sticky Nav with Debounce */
    if (window.innerWidth > 767) {
      $(".isio .pagebuilder-careers-menu-section").sticky({
        topSpacing: 125,
      });
    } else {
      $(".isio .pagebuilder-careers-menu-section").unstick();
    }
  }

  /*==========================================
=            Careers Navigation            =
==========================================*/
  // var careersMenuContainerWidth = $('.pagebuilder-careers-menu-section .inner-container').outerWidth();
  // var careersParentMenu         = $('.pagebuilder-careers-menu-section .parent-menu');
  // var careersNavPrev            = $('.pagebuilder-careers-menu-section .nav-prev');
  // var careersNavNext            = $('.pagebuilder-careers-menu-section .nav-next');
  // var careersMenuWidth          = 0;
  // var translatedValue = 0;

  // $( '.pagebuilder-careers-menu-section .parent-menu > li' ).each( function( index, el ) {
  // 	careersMenuWidth += parseInt($( this ).outerWidth());
  // } );

  // if ( careersMenuContainerWidth < careersMenuWidth ) {
  // 	careersNavPrev.click(function(e) {
  // 		if ( translatedValue < careersMenuContainerWidth ) {
  // 			translatedValue += careersMenuWidth/4;
  // 			careersParentMenu.animate({'margin-left': translatedValue + 'px'});
  // 		}
  // 	});
  // 	careersNavNext.click(function(e) {
  // 		if ( translatedValue < careersMenuContainerWidth ) {
  // 			careersNavPrev.removeClass('js-disabled');
  // 			translatedValue -= careersMenuWidth/4;
  // 			careersParentMenu.animate({'margin-left': translatedValue + 'px'});
  // 		}
  // 	});
  // };

  /*==============================================
=            Magnific Popup - Basic            =
==============================================*/
  if ($(window).outerWidth() < 1200) {
    $(".js-popup-bio").magnificPopup({
      mainClass: "mfp-fade",
    });
  }

  $(window).on("resize orientationchange", function () {
    if ($(window).outerWidth() < 1200) {
      $(".js-popup-bio").magnificPopup({
        mainClass: "mfp-fade",
      });
    } else {
      $(".js-popup-bio").magnificPopup("close");
    }
  });

  /*==============================================
=            Magnific Popup - Image            =
==============================================*/
  $(".js-popup-image").magnificPopup({
    type: "image",
    removalDelay: 300,
    mainClass: "mfp-fade",
    fixedContentPos: false, // disable scrollbar
    image: {
      verticalFit: true,
    },
  });

  /*==============================================
=            Magnific Popup - Video            =
==============================================*/
  $(".js-popup-video").magnificPopup({
    type: "iframe",
    removalDelay: 300,
    mainClass: "mfp-fade",
    fixedContentPos: false, // disable scrollbar
    iframe: {
      patterns: {
        youtube: {
          index: "youtube.com/", // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).
          id: function(url) {
            let embed = url.match(/\/embed\/(.*?)\//);
            let watch = url.match(/\?v=([A-Za-z0-9\-\_]*)/);
            if(embed) { return embed[1]; }
            if(watch) { return watch[1]; }
            else{ return url; }
          },
          // Or null - full URL will be returned
          // Or a function that should return %id%, for example:
          // id: function(url) { return 'parsed id'; }
          src: "//www.youtube.com/embed/%id%?autoplay=1&rel=0", // URL that will be set as a source for iframe.
        },
        vimeo: {
          index: "vimeo.com/",
          id: "/",
          src: "//player.vimeo.com/video/%id%?autoplay=1",
        },
        freshpaint: {
          index: "freshpaint-hipaa-videos.com",
          id: 'embed/',
          src: "https://www.freshpaint-hipaa-videos.com/youtube/embed/%id%?rel=0&autoplay=0&showinfo=0"
        }
      },
    },
  });
  // Top menu
  $(".pagebuilder-hero-links-section .tail-heading").click(function (e) {
    $(".pagebuilder-hero-links-section").toggleClass("js-active");
  });

  // Members sliding bio
  $(
    ".pagebuilder-members-bio-section .bio-trigger, .pagebuilder-members-bio-section .read-more"
  ).click(function (e) {
    e.preventDefault();
    $(this)
      .parents(".pagebuilder-member")
      .find(".bio-trigger, .read-more, .bio-block, .animation-block")
      .toggleClass("js-active");
  });

  // Careers menu
  $(".pagebuilder-careers-menu-trigger").click(function (e) {
    $(this).toggleClass("js-active");
    if ($(this).hasClass("js-active")) {
      $(this).attr("aria-expanded", "true");
      $(".pagebuilder-careers-menu-section")
        .attr("aria-hidden", "false")
        .find("a")
        .removeAttr("tabindex");
    } else {
      $(this).attr("aria-expanded", "false");
      $(".pagebuilder-careers-menu-section")
        .attr("aria-hidden", "true")
        .find("a")
        .attr("tabindex", "-1");
    }
    $(".pagebuilder-careers-menu-section").animate(
      {
        height: "toggle",
      },
      250
    );
  });

  $(".pagebuilder-careers-menu-section .has-dropdown > a").click(function (e) {
    $(this).parent("li").toggleClass("js-active");
    if ($(this).parent("li").hasClass("js-active")) {
      $(this).parent("li").attr("aria-expanded", "true");
      $(this)
        .siblings(".dropdown-block")
        .attr("aria-hidden", "false")
        .find("a, button")
        .removeAttr("tabindex");
    } else {
      $(this).parent("li").attr("aria-expanded", "false");
      $(this)
        .siblings(".dropdown-block")
        .attr("aria-hidden", "true")
        .find("a, button")
        .attr("tabindex", "-1");
    }
    $(this).siblings(".dropdown-block").animate(
      {
        height: "toggle",
      },
      250
    );
  });

  // Explore Site Dropdown
  var exploreSiteDropdown = eldebounce(function () {
    if (window.innerWidth > 767) {
      $(".pagebuilder-explore-section .has-dropdown > a")
        .unbind("click")
        .click(function (e) {
          $(this).attr("aria-expanded", "true");
          $(this)
            .siblings(".dropdown-block")
            .addClass("js-active")
            .attr("aria-hidden", "false")
			.find("a, button")
			.removeAttr("tabindex");
        });
      $(".pagebuilder-explore-section .btn-close").click(function (e) {
        $(this)
          .parents(".dropdown-block")
          .siblings("a")
          .attr("aria-expanded", "false");
        $(this)
          .parents(".dropdown-block")
          .removeClass("js-active")
          .attr("aria-hidden", "true")
		  .find("a, button")
		  .attr("tabindex", "-1");
      });
    } else {
      $(".pagebuilder-explore-section .has-dropdown > a")
        .unbind("click")
        .click(function (e) {
          // $( this ).parent( 'li' ).toggleClass( 'js-active' );
          $(this).siblings(".dropdown-block").animate(
            {
              height: "toggle",
            },
            250
          );
        });
    }
  }, 200);
  window.addEventListener("resize", exploreSiteDropdown);
  exploreSiteDropdown();

  // Calculate hero section height
  var bannerHeroHeight = eldebounce(function () {
    if (window.innerWidth > 991) {
      var navbarSuper = $(".navbar-super, .utility-nav").outerHeight();
      var navbarMain = $(".navbar-main, .main-nav").outerHeight();
      var careersMenu = 0;
      if ($(".pagebuilder-careers-menu-section").length) {
        var careersMenu = $(".pagebuilder-careers-menu-section").outerHeight();
      }
      var headerHeight = navbarSuper + navbarMain + careersMenu + 20;
      var windowHeight = $(window).height();
      var calcHeight = windowHeight - headerHeight;
      // $( '.pagebuilder-banner-hero-section, .pagebuilder-hero-section > .container' ).css( {
      // 	'max-height': calcHeight
      // } );
      // $(".pagebuilder-hero-section .img-split-block img").css({
      //   "max-height": calcHeight - 160,
      // });
    } else {
      $(
        ".pagebuilder-banner-hero-section, .pagebuilder-hero-section > .container, .pagebuilder-hero-section .img-split-block img"
      ).css({
        height: "auto",
      });
    }
  }, 200);
  window.addEventListener("resize", bannerHeroHeight);
  bannerHeroHeight();

  /*----------  Cards Slider  ----------*/
  function tseCardsSlider() {
    $(".pagebuilder-cards-slider").each(function () {
      $(this).slick({
        touchThreshold: 30,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 2,
        dots: true,
        appendDots: $(this)
          .parents(".pagebuilder-cards-slider-section")
          .find(".slick-slider-dots"),
        arrows: true,
        prevArrow:
          '<button type="button" class="slick-prev w-bg-blue"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 32 32" class="icon-arrow-left"><title>left_arrow_icon</title><path d="M12.366 28.21c-0.001 0-0.002 0-0.004 0-0.383 0-0.73-0.156-0.98-0.408l-10.975-10.968c-0.252-0.252-0.407-0.6-0.407-0.984s0.156-0.732 0.407-0.984l10.975-10.982c0.252-0.253 0.601-0.41 0.987-0.41 0.77 0 1.394 0.624 1.394 1.394 0 0.384-0.155 0.732-0.406 0.984l-9.998 9.991 9.998 9.991c0.252 0.252 0.407 0.6 0.407 0.984 0 0.768-0.623 1.391-1.391 1.391h-0z"></path><path d="M29.988 17.235h-28.479c-0.768 0-1.391-0.623-1.391-1.391s0.623-1.391 1.391-1.391v0h28.479c0.768 0 1.391 0.623 1.391 1.391s-0.623 1.391-1.391 1.391v0z"></path></svg></button>',
        nextArrow:
          '<button type="button" class="slick-next w-bg-blue"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 32 32" class="icon-arrow-right"><title>right_arrow_icon</title><path d="M19.014 28.21c-0.768-0-1.391-0.623-1.391-1.391 0-0.384 0.156-0.732 0.407-0.984l9.991-9.991-9.991-9.991c-0.242-0.25-0.391-0.591-0.391-0.967 0-0.768 0.623-1.391 1.391-1.391 0.376 0 0.717 0.149 0.967 0.391l10.974 10.974c0.252 0.252 0.407 0.6 0.407 0.984s-0.156 0.732-0.407 0.984l-10.975 10.975c-0.25 0.252-0.597 0.408-0.98 0.408-0.001 0-0.003 0-0.004 0h0z"></path><path d="M29.87 17.235h-28.479c-0.768 0-1.391-0.623-1.391-1.391s0.623-1.391 1.391-1.391v0h28.479c0.768 0 1.391 0.623 1.391 1.391s-0.623 1.391-1.391 1.391v0z"></path></svg></button>',
        responsive: [
          {
            breakpoint: 992,
            settings: "unslick",
          },
        ],
      });
    });
  }
  // console.log( $( window ).outerWidth() );
  if ($(window).outerWidth() > 991) {
    tseCardsSlider();
  }

  $(window).on("resize orientationchange", function () {
    if ($(this).outerWidth() > 991) {
      if (!$(".pagebuilder-cards-slider").hasClass("slick-initialized")) {
        tseCardsSlider();
      }
    } else {
      if ($(".pagebuilder-cards-slider").hasClass("slick-initialized")) {
        $(".pagebuilder-cards-slider").slick("unslick");
      }
    }
  });

  /*==========================================
=            Small Cards Slider            =
==========================================*/
  function tseScrollCardsSlider() {
    $(".pagebuilder-scroll-cards-slider").each(function () {
      $(this).slick({
        touchThreshold: 30,
        mobileFirst: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        appendDots: false,
        arrows: true,
        prevArrow:
          '<button type="button" class="slick-prev"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 32 32" class="icon-arrow-left"><title>left_arrow_icon</title><path d="M12.366 28.21c-0.001 0-0.002 0-0.004 0-0.383 0-0.73-0.156-0.98-0.408l-10.975-10.968c-0.252-0.252-0.407-0.6-0.407-0.984s0.156-0.732 0.407-0.984l10.975-10.982c0.252-0.253 0.601-0.41 0.987-0.41 0.77 0 1.394 0.624 1.394 1.394 0 0.384-0.155 0.732-0.406 0.984l-9.998 9.991 9.998 9.991c0.252 0.252 0.407 0.6 0.407 0.984 0 0.768-0.623 1.391-1.391 1.391h-0z"></path><path d="M29.988 17.235h-28.479c-0.768 0-1.391-0.623-1.391-1.391s0.623-1.391 1.391-1.391v0h28.479c0.768 0 1.391 0.623 1.391 1.391s-0.623 1.391-1.391 1.391v0z"></path></svg></button>',
        nextArrow:
          '<button type="button" class="slick-next"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 32 32" class="icon-arrow-right"><title>right_arrow_icon</title><path d="M19.014 28.21c-0.768-0-1.391-0.623-1.391-1.391 0-0.384 0.156-0.732 0.407-0.984l9.991-9.991-9.991-9.991c-0.242-0.25-0.391-0.591-0.391-0.967 0-0.768 0.623-1.391 1.391-1.391 0.376 0 0.717 0.149 0.967 0.391l10.974 10.974c0.252 0.252 0.407 0.6 0.407 0.984s-0.156 0.732-0.407 0.984l-10.975 10.975c-0.25 0.252-0.597 0.408-0.98 0.408-0.001 0-0.003 0-0.004 0h0z"></path><path d="M29.87 17.235h-28.479c-0.768 0-1.391-0.623-1.391-1.391s0.623-1.391 1.391-1.391v0h28.479c0.768 0 1.391 0.623 1.391 1.391s-0.623 1.391-1.391 1.391v0z"></path></svg></button>',
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 1199,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            },
          },
        ],
      });
    });
  }
  tseScrollCardsSlider();

  /*----------  Flip Slider  ----------*/
  function tseFlipSlider() {
    $(".pagebuilder-flip-slider").each(function () {
      $(this).slick({
        touchThreshold: 30,
        mobileFirst: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        appendDots: $(this).siblings(".slick-slider-dots"),
        arrows: true,
        prevArrow:
          '<button type="button" class="slick-prev"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 32 32" class="icon-arrow-left"><title>left_arrow_icon</title><path d="M12.366 28.21c-0.001 0-0.002 0-0.004 0-0.383 0-0.73-0.156-0.98-0.408l-10.975-10.968c-0.252-0.252-0.407-0.6-0.407-0.984s0.156-0.732 0.407-0.984l10.975-10.982c0.252-0.253 0.601-0.41 0.987-0.41 0.77 0 1.394 0.624 1.394 1.394 0 0.384-0.155 0.732-0.406 0.984l-9.998 9.991 9.998 9.991c0.252 0.252 0.407 0.6 0.407 0.984 0 0.768-0.623 1.391-1.391 1.391h-0z"></path><path d="M29.988 17.235h-28.479c-0.768 0-1.391-0.623-1.391-1.391s0.623-1.391 1.391-1.391v0h28.479c0.768 0 1.391 0.623 1.391 1.391s-0.623 1.391-1.391 1.391v0z"></path></svg></button>',
        nextArrow:
          '<button type="button" class="slick-next"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 32 32" class="icon-arrow-right"><title>right_arrow_icon</title><path d="M19.014 28.21c-0.768-0-1.391-0.623-1.391-1.391 0-0.384 0.156-0.732 0.407-0.984l9.991-9.991-9.991-9.991c-0.242-0.25-0.391-0.591-0.391-0.967 0-0.768 0.623-1.391 1.391-1.391 0.376 0 0.717 0.149 0.967 0.391l10.974 10.974c0.252 0.252 0.407 0.6 0.407 0.984s-0.156 0.732-0.407 0.984l-10.975 10.975c-0.25 0.252-0.597 0.408-0.98 0.408-0.001 0-0.003 0-0.004 0h0z"></path><path d="M29.87 17.235h-28.479c-0.768 0-1.391-0.623-1.391-1.391s0.623-1.391 1.391-1.391v0h28.479c0.768 0 1.391 0.623 1.391 1.391s-0.623 1.391-1.391 1.391v0z"></path></svg></button>',
        responsive: [
          {
            breakpoint: 575,
            settings: {
              variableWidth: true,
            },
          },
          {
            breakpoint: 767,
            settings: "unslick",
          },
        ],
      });
    });
  }
  if ($(window).outerWidth() < 768) {
    tseFlipSlider();
  }

  $(window).on("resize orientationchange", function () {
    if ($(this).outerWidth() < 768) {
      if (!$(".pagebuilder-flip-slider").hasClass("slick-initialized")) {
        tseFlipSlider();
      }
    } else {
      if ($(".pagebuilder-flip-slider").hasClass("slick-initialized")) {
        $(".pagebuilder-flip-slider").slick("unslick");
      }
    }
  });

  /*----------  Media Slider  ----------*/
  function tseMediaSlider() {
    $(".pagebuilder-media-slider").each(function () {
      $(this).slick({
        touchThreshold: 30,
        mobileFirst: true,
        speed: 500,
        dots: true,
        fade: true,
        appendDots: $(this).siblings(".slick-slider-dots"),
        arrows: true,
        prevArrow:
          '<button type="button" class="slick-prev w-bg-blue vw-5 for-media-slider"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 32 32" class="icon-arrow-left"><title>left_arrow_icon</title><path d="M12.366 28.21c-0.001 0-0.002 0-0.004 0-0.383 0-0.73-0.156-0.98-0.408l-10.975-10.968c-0.252-0.252-0.407-0.6-0.407-0.984s0.156-0.732 0.407-0.984l10.975-10.982c0.252-0.253 0.601-0.41 0.987-0.41 0.77 0 1.394 0.624 1.394 1.394 0 0.384-0.155 0.732-0.406 0.984l-9.998 9.991 9.998 9.991c0.252 0.252 0.407 0.6 0.407 0.984 0 0.768-0.623 1.391-1.391 1.391h-0z"></path><path d="M29.988 17.235h-28.479c-0.768 0-1.391-0.623-1.391-1.391s0.623-1.391 1.391-1.391v0h28.479c0.768 0 1.391 0.623 1.391 1.391s-0.623 1.391-1.391 1.391v0z"></path></svg></button>',
        nextArrow:
          '<button type="button" class="slick-next w-bg-blue vw-5 for-media-slider"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 32 32" class="icon-arrow-right"><title>right_arrow_icon</title><path d="M19.014 28.21c-0.768-0-1.391-0.623-1.391-1.391 0-0.384 0.156-0.732 0.407-0.984l9.991-9.991-9.991-9.991c-0.242-0.25-0.391-0.591-0.391-0.967 0-0.768 0.623-1.391 1.391-1.391 0.376 0 0.717 0.149 0.967 0.391l10.974 10.974c0.252 0.252 0.407 0.6 0.407 0.984s-0.156 0.732-0.407 0.984l-10.975 10.975c-0.25 0.252-0.597 0.408-0.98 0.408-0.001 0-0.003 0-0.004 0h0z"></path><path d="M29.87 17.235h-28.479c-0.768 0-1.391-0.623-1.391-1.391s0.623-1.391 1.391-1.391v0h28.479c0.768 0 1.391 0.623 1.391 1.391s-0.623 1.391-1.391 1.391v0z"></path></svg></button>',
      });
    });
  }
  tseMediaSlider();

  /*----------  Mixed Slider  ----------*/
  function tseMixedSlider() {
    $(".pagebuilder-mixed-slider").each(function () {
      var sliderInstance = $(this);

      sliderInstance.slick({
        touchThreshold: 30,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        dots: false,
        arrows: false,
        responsive: [
          {
            breakpoint: 992,
            settings: "unslick",
          },
        ],
      });

      sliderInstance.on(
        "beforeChange",
        function (event, slick, currentSlide, nextSlide) {
          if (
            sliderInstance.find(".slick-slide").eq(nextSlide).find("video")
              .length
          ) {
            sliderInstance
              .find(".slick-slide")
              .eq(nextSlide)
              .find("video")[0].currentTime = 0;
          }
        }
      );

      sliderInstance.on("afterChange", function (event, slick, currentSlide) {
        if (
          sliderInstance.find(".slick-slide").eq(currentSlide).find("video")
            .length
        ) {
          sliderInstance
            .find(".slick-slide")
            .eq(currentSlide)
            .find("video")[0]
            .play();
        }
      });

      sliderInstance.one("elinview", function (event, isInView) {
        if (isInView) {
          if (sliderInstance.find(".slick-slide").eq(0).find("video").length) {
            sliderInstance.find(".slick-slide").eq(0).find("video")[0].play();
          }
        }
      });

      var allTriggers = sliderInstance
        .parents("section")
        .find(".list-slide-triggers a");
      allTriggers.eq(0).addClass("js-active");
      allTriggers.click(function (e) {
        allTriggers.removeClass("js-active");
        $(this).addClass("js-active");
        var slideIndex = $(this).data("index");
        sliderInstance.slick("slickGoTo", slideIndex, false);
      });
    });
  }

  if ($(window).outerWidth() > 991) {
    tseMixedSlider();
  }

  $(window).on("resize orientationchange", function () {
    if ($(this).outerWidth() > 991) {
      if (!$(".pagebuilder-mixed-slider").hasClass("slick-initialized")) {
        tseMixedSlider();
      }
    } else {
      if ($(".pagebuilder-mixed-slider").hasClass("slick-initialized")) {
        $(".pagebuilder-mixed-slider").slick("unslick");
      }
    }
  });

  /*----------  CTA slider  ----------*/
  function tseCtaSlider() {
    $(".pagebuilder-cta-slider").each(function () {
      $(this).slick({
        infinite: true,
        touchThreshold: 30,
        mobileFirst: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        appendDots: $(this)
          .parents(".pagebuilder-cta-slider-section")
          .find(".slick-slider-dots"),
        arrows: true,
        prevArrow:
          '<button type="button" class="slick-prev w-bg-blue"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 32 32" class="icon-arrow-left"><title>left_arrow_icon</title><path d="M12.366 28.21c-0.001 0-0.002 0-0.004 0-0.383 0-0.73-0.156-0.98-0.408l-10.975-10.968c-0.252-0.252-0.407-0.6-0.407-0.984s0.156-0.732 0.407-0.984l10.975-10.982c0.252-0.253 0.601-0.41 0.987-0.41 0.77 0 1.394 0.624 1.394 1.394 0 0.384-0.155 0.732-0.406 0.984l-9.998 9.991 9.998 9.991c0.252 0.252 0.407 0.6 0.407 0.984 0 0.768-0.623 1.391-1.391 1.391h-0z"></path><path d="M29.988 17.235h-28.479c-0.768 0-1.391-0.623-1.391-1.391s0.623-1.391 1.391-1.391v0h28.479c0.768 0 1.391 0.623 1.391 1.391s-0.623 1.391-1.391 1.391v0z"></path></svg></button>',
        nextArrow:
          '<button type="button" class="slick-next w-bg-blue"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 32 32" class="icon-arrow-right"><title>right_arrow_icon</title><path d="M19.014 28.21c-0.768-0-1.391-0.623-1.391-1.391 0-0.384 0.156-0.732 0.407-0.984l9.991-9.991-9.991-9.991c-0.242-0.25-0.391-0.591-0.391-0.967 0-0.768 0.623-1.391 1.391-1.391 0.376 0 0.717 0.149 0.967 0.391l10.974 10.974c0.252 0.252 0.407 0.6 0.407 0.984s-0.156 0.732-0.407 0.984l-10.975 10.975c-0.25 0.252-0.597 0.408-0.98 0.408-0.001 0-0.003 0-0.004 0h0z"></path><path d="M29.87 17.235h-28.479c-0.768 0-1.391-0.623-1.391-1.391s0.623-1.391 1.391-1.391v0h28.479c0.768 0 1.391 0.623 1.391 1.391s-0.623 1.391-1.391 1.391v0z"></path></svg></button>',
        responsive: [
          {
            breakpoint: 575,
            settings: {
              variableWidth: true,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            },
          },
        ],
      });
      if ($(this).hasClass("data-infinite-false")) {
        $(this).slick(
          "setOption",
          "responsive",
          [
            {
              breakpoint: 1,
              settings: {
                infinite: false,
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 575,
              settings: {
                infinite: false,
                variableWidth: true,
              },
            },
            {
              breakpoint: 767,
              settings: {
                infinite: false,
                slidesToShow: 2,
                slidesToScroll: 2,
              },
            },
            {
              breakpoint: 991,
              settings: {
                infinite: false,
                slidesToShow: 3,
                slidesToScroll: 3,
              },
            },
          ],
          true
        );
      }
    });
  }
  tseCtaSlider();

  /*----------  CTA Blue slider  ----------*/
  function tseCtaBlueSlider() {
    $(".pagebuilder-cta-blue-slider").each(function () {
      $(this).slick({
        touchThreshold: 30,
        mobileFirst: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        appendDots: $(this)
          .parents(".pagebuilder-cta-slider-blue-section")
          .find(".slick-slider-dots"),
        arrows: true,
        prevArrow:
          '<button type="button" class="slick-prev"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 32 32" class="icon-arrow-left"><title>left_arrow_icon</title><path d="M12.366 28.21c-0.001 0-0.002 0-0.004 0-0.383 0-0.73-0.156-0.98-0.408l-10.975-10.968c-0.252-0.252-0.407-0.6-0.407-0.984s0.156-0.732 0.407-0.984l10.975-10.982c0.252-0.253 0.601-0.41 0.987-0.41 0.77 0 1.394 0.624 1.394 1.394 0 0.384-0.155 0.732-0.406 0.984l-9.998 9.991 9.998 9.991c0.252 0.252 0.407 0.6 0.407 0.984 0 0.768-0.623 1.391-1.391 1.391h-0z"></path><path d="M29.988 17.235h-28.479c-0.768 0-1.391-0.623-1.391-1.391s0.623-1.391 1.391-1.391v0h28.479c0.768 0 1.391 0.623 1.391 1.391s-0.623 1.391-1.391 1.391v0z"></path></svg></button>',
        nextArrow:
          '<button type="button" class="slick-next"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 32 32" class="icon-arrow-right"><title>right_arrow_icon</title><path d="M19.014 28.21c-0.768-0-1.391-0.623-1.391-1.391 0-0.384 0.156-0.732 0.407-0.984l9.991-9.991-9.991-9.991c-0.242-0.25-0.391-0.591-0.391-0.967 0-0.768 0.623-1.391 1.391-1.391 0.376 0 0.717 0.149 0.967 0.391l10.974 10.974c0.252 0.252 0.407 0.6 0.407 0.984s-0.156 0.732-0.407 0.984l-10.975 10.975c-0.25 0.252-0.597 0.408-0.98 0.408-0.001 0-0.003 0-0.004 0h0z"></path><path d="M29.87 17.235h-28.479c-0.768 0-1.391-0.623-1.391-1.391s0.623-1.391 1.391-1.391v0h28.479c0.768 0 1.391 0.623 1.391 1.391s-0.623 1.391-1.391 1.391v0z"></path></svg></button>',
        responsive: [
          {
            breakpoint: 575,
            settings: {
              variableWidth: true,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            },
          },
        ],
      });
      if ($(this).hasClass("data-infinite-false")) {
        $(this).slick(
          "slickSetOption",
          {
            infinite: false,
          },
          true
        );
      }
    });
  }
  tseCtaBlueSlider();

  /*----------  Gallery slider  ----------*/
  function tseGallerySlider() {
    $(".pagebuilder-gallery-slider").each(function () {
      $(this).slick({
        touchThreshold: 30,
        mobileFirst: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        appendDots: $(this)
          .parents(".pagebuilder-gallery-slider-section")
          .find(".slick-slider-dots"),
        arrows: true,
        prevArrow:
          '<button type="button" class="slick-prev w-bg-blue"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 32 32" class="icon-arrow-left"><title>left_arrow_icon</title><path d="M12.366 28.21c-0.001 0-0.002 0-0.004 0-0.383 0-0.73-0.156-0.98-0.408l-10.975-10.968c-0.252-0.252-0.407-0.6-0.407-0.984s0.156-0.732 0.407-0.984l10.975-10.982c0.252-0.253 0.601-0.41 0.987-0.41 0.77 0 1.394 0.624 1.394 1.394 0 0.384-0.155 0.732-0.406 0.984l-9.998 9.991 9.998 9.991c0.252 0.252 0.407 0.6 0.407 0.984 0 0.768-0.623 1.391-1.391 1.391h-0z"></path><path d="M29.988 17.235h-28.479c-0.768 0-1.391-0.623-1.391-1.391s0.623-1.391 1.391-1.391v0h28.479c0.768 0 1.391 0.623 1.391 1.391s-0.623 1.391-1.391 1.391v0z"></path></svg></button>',
        nextArrow:
          '<button type="button" class="slick-next w-bg-blue"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 32 32" class="icon-arrow-right"><title>right_arrow_icon</title><path d="M19.014 28.21c-0.768-0-1.391-0.623-1.391-1.391 0-0.384 0.156-0.732 0.407-0.984l9.991-9.991-9.991-9.991c-0.242-0.25-0.391-0.591-0.391-0.967 0-0.768 0.623-1.391 1.391-1.391 0.376 0 0.717 0.149 0.967 0.391l10.974 10.974c0.252 0.252 0.407 0.6 0.407 0.984s-0.156 0.732-0.407 0.984l-10.975 10.975c-0.25 0.252-0.597 0.408-0.98 0.408-0.001 0-0.003 0-0.004 0h0z"></path><path d="M29.87 17.235h-28.479c-0.768 0-1.391-0.623-1.391-1.391s0.623-1.391 1.391-1.391v0h28.479c0.768 0 1.391 0.623 1.391 1.391s-0.623 1.391-1.391 1.391v0z"></path></svg></button>',
        responsive: [
          {
            breakpoint: 575,
            settings: {
              variableWidth: true,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            },
          },
          {
            breakpoint: 1300,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4,
            },
          },
        ],
      });
    });
  }
  tseGallerySlider();

  let isIO = !!$(".isio");
  // PageBuilder Doctors Block
  if (isIO) {
    $(".pagebuilder-members-card-section .pagebuilder-doctor-card").on(
      "click",
      function (e) {
        e.preventDefault();

        let $this = $(this);
        let doctorInfo = $($this.children(".doctor-info"));
        let doctorTitle = doctorInfo.children(".doctor-title").text();
        let doctorServices = doctorInfo.children(".doctor-services").text();
        let doctorBio = doctorInfo.children(".doctor-bio").html();
        let doctorTwitterLink = doctorInfo
          .children(".doctor-twitter-link")
          .text();
        let doctorlinkedinLink = doctorInfo
          .children(".doctor-linkedin-link")
          .text();
        let doctorImg = doctorInfo
          .children(".doctor-img-block")
          .find("img")
          .attr("src");

        $(".modal-name").text(doctorTitle);
        $(".modal-services").text(doctorServices);
        $(".modal-body .img-block img").attr("src", doctorImg);
        $(".modal-body .bio").html(doctorBio);
        if (doctorTwitterLink.length) {
          $(".modal-body .twitter-link-block").css("display", "block");
          $(".modal-body .twitter-link").attr("href", doctorTwitterLink);
        } else {
          $(".modal-body .twitter-link-block").css("display", "none");
        }
        if (doctorlinkedinLink.length) {
          $(".modal-body .linkedin-link-block").css("display", "block");
          $(".modal-body .linkedin-link").attr("href", doctorlinkedinLink);
        } else {
          $(".modal-body .linkedin-link-block").css("display", "none");
        }

        $("#bio-modal").modal("show");
      }
    );
  }

  $('.pagebuilder-cta-slider .slick-slide').removeAttr('tabindex');
}); // Document Ready


// @TODO: Take this out of jQuery.
//        Below is a start, but still needs a modal.
/**
  * const bioCards = document.querySelectorAll('.pagebuilder-bio-card');
  * bioCards.forEach( (card) => {
  *   card.addEventListener('click', (e) => {
  *     e.preventDefault();
  *
  *     const bioName = card.querySelector(".bio-info .name");
  *     const bioTitle = card.querySelector(".bio-info .title");
  *     const bioDesc = card.querySelector(".bio-info .desc");
  *     const bioTwitterLink = card.querySelector(".bio-info .twitter-link");
  *     const bioLinkedinLink = card.querySelector(".bio-info .linkedin-link");
  *     const bioImg = card.querySelector(".bio-info .img-block img");
  *
  *     let profileLinks = card.querySelector('.bio-info .profile-link');
  *     let profileLinksBlock = card.querySelector('#profile-links-block');
  *
  *     const bio = {
  *       'name' : bioName ? bioName.innerText : "",
  *       'title' : bioTitle ? bioTitle.innerText : "",
  *       'desc' : bioDesc ? bioDesc.innerHTML : "",
  *       'twitter': bioTwitterLink ? bioTwitterLink.innerText : false,
  *       'linkedin': bioLinkedinLink ? bioLinkedinLink.innerText : false,
  *       'image': bioImg ? bioImg.getAttribute('src') : false,
  *       'links' : profileLinks
  *     };
  *
  *   });
  * });
*/

$(".pagebuilder-members-card-section .pagebuilder-bio-card").on(
  "click",
  function (e) {
    e.preventDefault();

    let $this = $(this);
    let bioInfo = $($this.children(".bio-info"));
    let bioName = bioInfo.children(".name").text();
    let bioTitle = bioInfo.children(".title").text();
    let bioDesc = bioInfo.children(".desc").html();
    let bioTwitterLink = bioInfo.children(".twitter-link").text();
    let bioLinkedinLink = bioInfo.children(".linkedin-link").text();
    let bioImg = bioInfo.children(".img-block").find("img").attr("src");
    let profileLinks = bioInfo.children('.profile-link');
    let profileLinksBlock = $('#profile-links-block');


    // Clear the Profile Links Block
    profileLinksBlock.html("");

    $(".modal-name").text(bioName);
    $(".modal-title").text(bioTitle);
    $(".modal-body .img-block img").attr("src", bioImg);
    $(".modal-body .bio").html(bioDesc);
    if (bioTwitterLink.length) {
      $(".modal-body .twitter-link-block").removeClass('d-none');
      $(".modal-body .twitter-link").attr("href", bioTwitterLink);
    } else {
      $(".modal-body .twitter-link-block").addClass('d-none');
    }
    if (bioLinkedinLink.length) {
      $(".modal-body .linkedin-link-block").removeClass('d-none').addClass('d-inline-block');
      $(".modal-body .linkedin-link").attr("href", bioLinkedinLink);
    } else {
      $(".modal-body .linkedin-link-block").addClass('d-none').removeClass('d-inline-block');
    }

    profileLinks.each((index, element) => {
      let linkUrl  = $(element).data('url');
      let linkText = $(element).data('text');
      let linkNewWindow = $(element).data('new-window') == 1 ? "_blank" : "_self";
      let linkId = element.id;
      let linkElement = $("<a>", {
        class: "profile-link",
        href: linkUrl,
        target: linkNewWindow
      });
      let linkBlock = $('<div>', { class: 'profile-link-block normal-link-block mb-3' });
      $(linkElement).text(linkText);
      linkBlock.html(linkElement);
      profileLinksBlock.append(linkBlock);
    });

    $modals = $('.bio-modal');
    if( $modals.length > 0 ) {
      var modal = $modals[0];
      $(modal).modal('show');
    }

  }
);

$(".pagebuilder-wrapper .parent-menu .has-dropdown > a").on(
  "click",
  function (e) {
    if (window.innerWidth < 991) {
      e.preventDefault();
    }
  }
);

